import React from "react";
import styles from "./BoxHead.module.scss";
// import medicalradiolgraphy2 from "../../../assets/row-medical-radiolgraphy2.png";
import family_2 from '../../../assets/family_2.jpg'
import new_about from '../../../assets/new_about.HEIC'
// import rowmedical from "../../../assets/row-medical-computed-radiography.png";
// import analog_horizon from "../../../assets/row-medical-analog-horizon.jpg";
// import medicalsoftware from "../../../assets/row-medical-software.png";
// import medicalprinting from "../../../assets/row-medical-printing.png";
// import medicaldental from "../../../assets/row-medical-dental.png";
import { Link } from "react-router-dom";
// import { GoDotFill } from "react-icons/go";

const BoxHead = () => {
  return (
    <section className={styles.box_container}>
      <div className={styles.___container}>
        {/* Box 1  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={family_2} alt='MILLENSYS family' loading="lazy"/>
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='/about' className={styles._headding}>
              Who we are ?
              </Link>
              <strong className={styles.__strong}>
              Healthcare providers place their trust in MILLENSYS as a single, comprehensive vendor for nearly all their essential management software needs. 
              </strong>
              <p className={styles.__content}>
              With an extensive portfolio of software products spanning clinical, imaging, workflow, automation, telehealth, and financial management, competition is typically minimal. 
              </p>
              <p className={styles.__content}>
              Our commitment to offering a wide spectrum of integrated solutions ensures that healthcare providers can streamline their operations efficiently, reduce complexity, and achieve optimal performance. By choosing MILLENSYS, healthcare organizations gain access to a unified suite of software products, simplifying their software procurement process and enhancing their ability to deliver high-quality care."
              </p>
            </div>
          </div>
        </div>

        {/* Box 2  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
              <Link to='/about' className={styles._headding}>
              Why Choose Us?
              </Link>
              <strong className={styles.__strong}>
              MILLENSYS is dedicated to revolutionizing healthcare delivery through innovative solutions.
              Our advanced telemedicine and teleradiology platforms, coupled with AI-driven insights, 
                enable remote diagnosis and treatment, 
              </strong>
              <p className={styles.__content}>
    
                saving healthcare providers valuable time while maximizing patient care.
                By harnessing the power of cloud technology and adhering to industry standards like IHE/HL7, 
                we ensure seamless integration and secure data management.
                Our commitment to exceptional customer service complements our technological prowess, 
                providing timely support and optimizing your return on investment. 
                Partner with MILLENSYS to elevate patient care, enhance efficiency, and drive business growth.
              </p>
              {/* <button className={styles["product___btn"]}>
                <Link to={'/about'}>Learn More</Link>
              </button> */}
            </div>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={new_about} alt='MILLENSYS-blog-events' loading="lazy"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BoxHead;
